export default __webpack_public_path__ + "static/media/gt.1e001a10.svg";